import { NavLink, useMatch } from "react-router";

import { Badge } from "./badge";
import { Icon, type IconType } from "./icon";
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "./sidebar";

export interface NavItem {
  title: string;
  url: string;
  icon: IconType;
  end?: boolean;
  /** A count that needs attention; nothing at 0. */
  badge?: number;
}

function NavMainItem({ item }: { item: NavItem }) {
  const isActive = !!useMatch({ path: item.url, end: item.end ?? false });
  return (
    <SidebarMenuItem>
      <SidebarMenuButton asChild isActive={isActive} tooltip={item.title}>
        <NavLink to={item.url} end={item.end} viewTransition>
          <Icon icon={item.icon} />
          <span className="truncate">{item.title}</span>
          {!!item.badge && (
            <Badge
              variant="destructive"
              className="ml-auto tabular-nums group-data-[collapsible=icon]:hidden"
            >
              {item.badge}
            </Badge>
          )}
        </NavLink>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
}

export function NavMain({
  label,
  items,
}: {
  label?: string;
  items: NavItem[];
}) {
  if (items.length === 0) return null;
  return (
    <SidebarGroup>
      {label && <SidebarGroupLabel>{label}</SidebarGroupLabel>}
      <SidebarMenu>
        {items.map((item) => (
          <NavMainItem key={item.url} item={item} />
        ))}
      </SidebarMenu>
    </SidebarGroup>
  );
}
